import { render, staticRenderFns } from "./PartnerSearch.vue?vue&type=template&id=10069b16&"
import script from "./PartnerSearch.vue?vue&type=script&lang=js&"
export * from "./PartnerSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports